import { render, staticRenderFns } from "./BarberViee.vue?vue&type=template&id=698568f1&scoped=true"
import script from "./BarberViee.vue?vue&type=script&lang=js"
export * from "./BarberViee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698568f1",
  null
  
)

export default component.exports